var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-row" }, [
        _c("div", { staticClass: "left" }, [
          !_vm.showDetail
            ? _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-small swb-btn-small",
                  on: {
                    click: function($event) {
                      _vm.addAppliedShop()
                    }
                  }
                },
                [_vm._v("新增门店")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.selectComList, border: "", height: "565" }
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "行号",
              align: "center",
              width: "50"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "bizUnitName",
              label: "业务单元",
              width: "200",
              align: "left",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "bizAreaName",
              label: "经营区域",
              width: "180",
              align: "left",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "bizFormName", label: "经营业态", align: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "mgmtSmlAreaName", label: "管理区域", align: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "quantity", label: "服务费用", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("el-input", {
                      attrs: {
                        type: "number",
                        min: 0,
                        disabled:
                          (_vm.servcModify && rows.row.id != null) ||
                          _vm.showDetail
                      },
                      on: {
                        change: function($event) {
                          _vm.priceChange(rows.$index)
                        }
                      },
                      model: {
                        value: rows.row.price,
                        callback: function($$v) {
                          _vm.$set(rows.row, "price", $$v)
                        },
                        expression: "rows.row.price"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          !_vm.showDetail
            ? _c("el-table-column", {
                attrs: { label: "操作", align: "left", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        !(
                          (_vm.servcModify && rows.row.id != null) ||
                          _vm.showDetail
                        )
                          ? _c(
                              "a",
                              {
                                staticClass: "swb-btn swb-btn-link",
                                on: {
                                  click: function($event) {
                                    _vm.removeComInfo(rows.$index)
                                  }
                                }
                              },
                              [_vm._v("移除")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-449224f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449224f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractServcOrgPriceList.vue
// module id = 3245
// module chunks = 0